module.exports = __webpack_public_path__ + "static/img/xiaoyuanzhaopin.9c558f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jobs/xiaoyuanzhaopin.png
// module id = RdoL
// module chunks = 1